/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pause_medium'
export default icon
